import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-role-down",
  "use": "icon-role-down-usage",
  "viewBox": "0 0 8 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 10\" id=\"icon-role-down\">\r\n  <defs>\r\n    <style>\r\n      #icon-role-down .cls-1 {\r\n        fill: #909399;\r\n        fill-rule: evenodd;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"icon-role-down_下\" class=\"cls-1\" d=\"M703.759,225.948a0.64,0.64,0,0,0,.729-0.158l3.318-3.583a0.75,0.75,0,0,0,0-1.012,0.64,0.64,0,0,0-.947.006l-2.123,2.214v-6.7a0.745,0.745,0,0,0-1.489,0v6.662l-2.095-2.152a0.64,0.64,0,0,0-.947,0,0.75,0.75,0,0,0,0,1.011l3.336,3.553h0l0,0a0.673,0.673,0,0,0,.21.147,0.055,0.055,0,0,1,.008.006h0Zm0,0\" transform=\"translate(-700 -216)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/role-down.svg
// module id = VMbA
// module chunks = 127